export default __webpack_public_path__ + "static/media/drone_white.a3694863.svg";